function d(d){return/(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$)/.test(d)}export{d as default};
//# sourceMappingURL=validate.js.map
